import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import * as styles from './Header.css';
import ConsultantMobile from './images/consultantMobile.svg';

export interface IHeaderProps {
  buttonsRef: React.RefObject<HTMLDivElement>;
  callButton: React.ReactNode;
  requestButton: React.ReactNode;
}

export const Header: React.FC<IHeaderProps> = ({ buttonsRef, callButton, requestButton }) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone' || deviceType === 'tablet';

  return (
    <section className={styles['header']} data-testid="LandingPageHeader">
      {isMobile && <img src={ConsultantMobile} className={styles['consultant-image']} />}
      <div className={styles['text']}>
        <h1 className={styles['title']}>
          <span className={styles['free']}>Бесплатно </span>поможем выбрать квартиру в&nbsp;новостройке
        </h1>
        <div className={styles['description']}>
          Консультант Циан подберёт квартиру по вашим параметрам и ответит на все вопросы
        </div>
        <div className={styles['button-group']}>
          <div ref={buttonsRef}>
            <div className={styles['button']}>{callButton}</div>
            <div className={styles['button']}>{requestButton}</div>
          </div>
        </div>
      </div>
    </section>
  );
};
